import Flickity from 'flickity';
import barba from '@barba/core';

class Home {
    constructor() {
        this.namespaces = [
            document.querySelector('.page-fragments'), 
            document.querySelector('.page-fragment-article'),
            document.querySelector('.page-fragment-issue')
        ].filter(Boolean);
        this.siteWidth = 1100;
        this.initPage();
    }

    initPage() {
        if (!this.namespaces.length) return;
        this.setupCarousels();
        this.adjustBanners();
        this.setupWindowEvents();
        this.setupListeners();
    }

    setupListeners() {

        const sups = document.querySelectorAll('sup');
        const footNotes = document.querySelector('.article-references');

        sups.forEach((sup) => {
            sup.addEventListener('click', (e) => {
                footNotes.scrollIntoView({ block: 'end',  behavior: 'smooth' });
            });
        });

        this.issueSelector = document.querySelector('.issue-selector');
        if (this.issueSelector) this.issueSelector.addEventListener('change', () => this.handleIssueChange());

        this.nextButtons = document.querySelectorAll('.btn-next');
        this.prevButtons = document.querySelectorAll('.btn-prev');

        this.nextButtons.forEach((button) => {
            button.addEventListener('click', () => this.bannerNext());
        });

        this.prevButtons.forEach((button) => {
            button.addEventListener('click', () => this.bannerPrev());
        });

        this.socialShareLinkedIn = document.querySelector('.social-share-linkedin');
        if (this.socialShareLinkedIn) this.socialShareLinkedIn.addEventListener('click', () => this.shareLinkedIn());

        this.socialShareX = document.querySelector('.social-share-x');
        if (this.socialShareX) this.socialShareX.addEventListener('click', () => this.shareX());
    }

    shareX() {
        const url = window.location.href;
        const title = document.title;
        const text = document.querySelector('meta[name="description"]').content;
        const xUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title} - ${text}`;
        window.open(xUrl, '_blank');
    }

    shareLinkedIn() {
        const url = window.location.href;
        const title = document.title;
        const text = document.querySelector('meta[name="description"]').content;
        const linkedInUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}&summary=${text}`;
        window.open(linkedInUrl, '_blank');
    }

    bannerNext() {
        this.issueCarousel.next();
    }

    bannerPrev() {
        this.issueCarousel.previous();
    }

    handleIssueChange(e) {
        barba.go(`/fragments/${this.issueSelector.value}`);
    }

    setupCarousels() {
        const issueCarouselElement = document.querySelector('.issue-carousel');
        if (issueCarouselElement) this.issueCarousel = new Flickity(document.querySelector('.issue-carousel'), { wrapAround: true });
    }

    adjustBanners () {
        const articleBanner = document.querySelector('.header-image .inner');
        const caption = document.querySelector('.caption');
        // adjust UI positions
        if (articleBanner && window.innerWidth > this.siteWidth) {
            articleBanner.style.left = `${(window.innerWidth - this.siteWidth) / 2}px`;
            caption.style.marginLeft = `${(window.innerWidth - this.siteWidth) / 2}px`;
        }
    }

    setupWindowEvents() 
    {
        window.addEventListener('resize', this.resizeHandler.bind(this));
    }

    resizeHandler() {
        this.adjustBanners();
    }

    destroy() {
       window.removeEventListener('resize', this.resizeHandler);
       if (this.issueSelector) this.issueSelector.removeEventListener('change', this.handleIssueChange);
       
       this.nextButtons.forEach((button) => {
        button.removeEventListener('click', () => this.bannerNext());
        });

        this.prevButtons.forEach((button) => {
            button.removeEventListener('click', () => this.bannerPrev());
        });
    }
}
export default Home;